// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3rOro","dragIcon":"SortableItem_dragIcon__2_8CF","disabled":"SortableItem_disabled__34lMB"};